<current-sked-task-detail
  [notInSked]="true"
  (notInSkedBack)="onBack()"
  (notInSkedGet)="onGet()"
></current-sked-task-detail>
